import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { useEffect, useState } from 'react'
import Button from '../../shared/button/Btn'
import PageTopTitle from '../../shared/PageTopTitle'
import { useLocation } from 'react-router-dom'
import { useScrollLock } from '../../../hooks/useScrollLock'
import { showModal, showNestedModal } from '../../../features/modal/modalSlice'
import { handleActiveSelect } from '../../../features/layout/layoutSlice'
import { setIsKayitLoad } from '../../../features/kayit/kayitSlice'
import MapSide from "../../../components/load/mainSides/mapSide/MapSide";
import InputSide from "../../../components/load/mainSides/inputSide/InputSide";
import { toast } from 'react-toastify'
import submitLoadPermission from '../../../helper/load/submitLoadPermission'
import { setErrors, setRequiredPlacesErrors } from '../../../features/addLoad/addLoadSlice'

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1500px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;

        .content{
            width: 100%;
            display: flex;
            flex-direction: column;
            height: 650px;
            overflow: auto;
            padding: 40px;

            .top-container{
                width: 100%;
            }
            
            .side-container{
                width: 100%;
                display: flex;
                gap: 40px;
            }
        
        }

        .btn-container{
            width: 100%;
            height: 70px;
            margin: 0 40px;
            gap: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-top: 1px solid ${({theme}) => theme.mainBorderColor};
        }
    }
`
const KayitliYukEkleNewModal = () => {
  const dispatch = useDispatch()

  const location = useLocation()
  const {aracData, yukData, paketlemeData, paymentData, route, routeDistance} = useSelector(state => state.addLoad)

  const {modalLocation } = useSelector(state => state.modal)
  const { lockScroll, unlockScroll } = useScrollLock();

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleSubmit = () => {
        if(submitLoadPermission(route, aracData, paymentData, yukData, paketlemeData, routeDistance)){
            dispatch(showNestedModal("addLoadYuklemeSecenekleriForKayit"))
        }

        else{
            toast.error(`Lütfen gerekli alanları doldurduktan sonra tekrar deneyin`, {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            dispatch(setErrors(true))
        }
    }

    useEffect(()=>{
        dispatch(setIsKayitLoad(true))
        return () => {
            dispatch(setIsKayitLoad(false))
            dispatch(setErrors(false))
        }
    },[])

  return (
    <ModalContainer onClick={()=> {dispatch(showModal(null)); dispatch(setIsKayitLoad(false))}}>
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <PageTopTitle title={"Ön Tanımlı Yük Ekle"}/>
            <div className="content">
                <div className="top-container"></div>
                <div className="side-container">
                    <InputSide yukKayit />
                    <MapSide yukKayit />
                </div>
            </div>
            <div className="btn-container">
                <Button bgColor="#E85546" color="#fff" width={"220px"} handleClick={handleSubmit}>Yük Kaydet</Button>
                <Button bgColor="#fff" color="#E85546" width={"220px"} handleClick={() => {dispatch(showModal(null)); dispatch(setIsKayitLoad(false))}}>Vazgeç</Button>
            </div>
        </div>
    </ModalContainer>
  )
}

export default KayitliYukEkleNewModal

